import React, { useState, useEffect } from "react";
import "../ui/table/table.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import "./inventoryTable.css";

const PAGE_SIZE = 10;

const InventoryTable = ({ data = [], loading = false, editable = false, editMode, onDelete }) => {
  const [page, setPage] = useState(1);
  const totalPages = Math.max(1, Math.ceil(data.length / PAGE_SIZE));
  const paginated = data.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  useEffect(() => { setPage(1); }, [data.length]);

  if (loading) return <p>Loading...</p>;

  return (
    <div className="card">
      <div className="card-header">
        <h3>Inventory</h3>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <span className="table-count">{data.length} item{data.length !== 1 ? "s" : ""}</span>
          <Link to="/inventory" className="viewbtn">View All</Link>
        </div>
      </div>
      <div className="table-responsive">
        <table>
          <thead>
            <tr>
              <th>Image</th>
              <th>Name</th>
              <th>Category</th>
              <th>SKU</th>
              <th>Stock</th>
              <th>Price</th>
              {editable && <th>Action</th>}
            </tr>
          </thead>
          <tbody>
            {paginated.length === 0 ? (
              <tr>
                <td colSpan={editable ? 7 : 6} style={{ textAlign: "center", padding: "2rem", color: "#888" }}>
                  No inventory items found.
                </td>
              </tr>
            ) : (
              paginated.map((item) => (
                <tr key={item._id}>
                  <td>
                    <img
                      src={item.image || "https://via.placeholder.com/50"}
                      alt={item.itemName}
                      style={{ width: "48px", height: "48px", objectFit: "cover", borderRadius: "6px" }}
                    />
                  </td>
                  <td>{item.itemName}</td>
                  <td style={{ textTransform: "capitalize" }}>{item.category}</td>
                  <td>{item.sku || "—"}</td>
                  <td>
                    <span className={item.stock === 0 ? "stock-badge out" : item.stock <= 5 ? "stock-badge low" : "stock-badge ok"}>
                      {item.stock || 0}
                    </span>
                  </td>
                  <td>₹{Number(item.price).toLocaleString("en-IN")}</td>
                  {editable && (
                    <td>
                      <div className="action-btns">
                        <button className="action-btn edit" onClick={() => editMode && editMode(item)} title="Edit">
                          <FontAwesomeIcon icon="pen-to-square" />
                        </button>
                        <button className="action-btn delete" onClick={() => onDelete && onDelete(item)} title="Delete">
                          <FontAwesomeIcon icon="trash-can" />
                        </button>
                      </div>
                    </td>
                  )}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {data.length > PAGE_SIZE && (
        <div className="pagination-bar">
          <button className="page-btn" onClick={() => setPage((p) => Math.max(1, p - 1))} disabled={page === 1}>
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>
          <span className="page-info">Page {page} of {totalPages}</span>
          <button className="page-btn" onClick={() => setPage((p) => Math.min(totalPages, p + 1))} disabled={page === totalPages}>
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>
      )}
    </div>
  );
};

export default InventoryTable;
